import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import PopUpModal from "../Modal";
import * as postapi from "../../api/postapi";
import useApi from "../../Hooks/useApi";
import { toast } from "react-toastify";
import { RiFlag2Line, RiFlagOffLine } from "react-icons/ri";
import styles from "./OrdersWorkspace/OrdersWorkspace.module.css";

const MarkSpamModal = ({ show, data, onHide, toggle, mode = "mark" }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [error, setError] = useState("");
  const [reason, setReason] = useState("");
  const markAsSpamCall = useApi(postapi.markAsSpam, { hasCatchError: true });
  const unmarkSpamCall = useApi(postapi.unmarkSpam, { hasCatchError: true });
  const close = () => {
    setIsClicked(false);
    onHide();
    setError("");
    setReason("");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsClicked(true);
      const response = mode === "unmark"
        ? await unmarkSpamCall.request(data.id)
        : await markAsSpamCall.request(data.id, reason || undefined);
      if (response.status === 200) {
        toast.success(`${response?.data?.message}`, {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        close();
        toggle();
      }
    } catch (error) {
      setError(error.response.data.error.message);
      setIsClicked(false);
    }
  };
  const isUnmark = mode === "unmark";
  return (
    <PopUpModal
      title={isUnmark ? "Remove Spam Status" : "Mark as Spam"}
      show={show}
      onHide={close}
      closeButton={false}
    >
      <>
        {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}

        <div>
          <span className="d-flex justify-content-center pb-3 text-center">
            {isUnmark
              ? "Remove the spam flag from this order? It will be treated as a legitimate order again."
              : "Mark this order as spam? Flagged orders are excluded from default listings and dashboard insights."}
          </span>
        </div>

        {!isUnmark && (
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold" style={{ fontSize: "14px" }}>
              Reason (optional)
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Enter reason for marking as spam..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{ fontSize: "14px" }}
            />
          </Form.Group>
        )}

        <div className={styles.modalActions}>
          <Button className={styles.modalAction} variant="outline-secondary" onClick={close}>
            Cancel
          </Button>
          <Button
            className={styles.modalAction}
            variant={isUnmark ? "warning" : "primary"}
            onClick={handleSubmit}
            disabled={isClicked}
          >
            {isUnmark ? <><RiFlagOffLine aria-hidden="true" /> Remove Spam</> : <><RiFlag2Line aria-hidden="true" /> Spam</>}
          </Button>
        </div>
      </>
    </PopUpModal>
  );
};

export default MarkSpamModal;
